module.exports = __webpack_public_path__ + "static/detail.9598980a.png";